import { TFunction } from 'i18next';

import { DISTRICT_TABS } from '@domain/districts';

import { Drupal } from '@typings/drupal';

export default (t: TFunction, districtId?: string): Array<Drupal.MenuItem> => [
  {
    id: DISTRICT_TABS.DETAILS,
    label: t('district-details.menu.details', 'Details'),
    path: `/domui/district/${districtId}/details`,
    language_prefix: 'en',
  },
  {
    id: DISTRICT_TABS.CLUBS,
    label: t('district-details.menu.clubs', 'Clubs'),
    path: `/domui/district/${districtId}/clubs`,
    language_prefix: 'en',
  },
  {
    id: DISTRICT_TABS.MEMBERS,
    label: t('district-details.menu.members', 'Members'),
    path: `/domui/district/${districtId}/members`,
    language_prefix: 'en',
  },
  {
    id: DISTRICT_TABS.FINANCE,
    label: t('district-details.menu.finance', 'Finance'),
    path: `/domui/district/${districtId}/finance`,
    language_prefix: 'en',
  },
  {
    id: DISTRICT_TABS.CONFERENCES,
    label: t('district-details.menu.conferences', 'Conferences'),
    path: `/domui/district/${districtId}/conferences`,
    language_prefix: 'en',
  },
  {
    id: DISTRICT_TABS.REPORTS,
    label: t('district-details.menu.reports', 'Reports'),
    path: `/domui/district/${districtId}/reports`,
    language_prefix: 'en',
  },
  {
    id: DISTRICT_TABS.DASHBOARD,
    label: t('district-details.menu.dashboard', 'Dashboard'),
    path: `/domui/district/${districtId}/dashboard`,
    language_prefix: 'en',
  },
];
